<script setup>
import { computed, getCurrentInstance } from 'vue'

const props = defineProps({
  label: { type: String, default: '' },
  type: { type: String, default: 'text' },
  placeholder: { type: String, default: '' },
  hasError: { type: Boolean, default: false },
  message: { type: String, default: '' },
  size: {
    type: String,
    default: 'md',
    validator: value => ['sm', 'md'].includes(value),
  },
  disabled: { type: Boolean, default: false },
})

const model = defineModel({ type: [String, Number], default: '' })

defineOptions({
  inheritAttrs: false,
})

const { uid } = getCurrentInstance()
const uniqueId = computed(() => `input-${uid}`)

const sizeClass = computed(() =>
  props.size === 'sm' ? 'h-8 !px-3 !py-2' : 'h-10 !px-3 !py-2.5'
)
</script>

<template>
  <div class="flex flex-col min-w-0 gap-1">
    <label
      v-if="label"
      :for="uniqueId"
      class="mb-0.5 text-heading-3 text-n-slate-12"
    >
      {{ label }}
    </label>
    <input
      :id="uniqueId"
      v-model="model"
      v-bind="$attrs"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      class="block w-full mb-0.5 text-sm border-none rounded-xl outline outline-1 outline-offset-[-1px] bg-n-alpha-black2 placeholder:text-n-slate-10 text-n-slate-12 disabled:opacity-50 disabled:cursor-not-allowed"
      :class="[
        sizeClass,
        hasError
          ? 'outline-n-ruby-8 hover:outline-n-ruby-9 focus:outline-n-ruby-9'
          : 'outline-n-weak hover:outline-n-slate-6 focus:outline-n-brand',
      ]"
    />
    <span v-if="hasError && message" class="text-xs text-n-ruby-9">
      {{ message }}
    </span>
  </div>
</template>
